import {
  Corner,
  Root,
  Scrollbar,
  Thumb,
  Viewport,
} from '@radix-ui/react-scroll-area';

import { styled } from '@/stitches.config';

const DEFAULT_SCROLLBAR_SIZE = '3px';

const StyledScrollArea = styled(Root, {
  width: '100%',
  height: '100%',
  overflow: 'hidden',
});

const StyledViewport = styled(Viewport, {
  width: '100%',
  height: '100%',
});

const StyledThumb = styled(Thumb, {
  flex: 1,
  background: '$gray600',
  br: '$rounded-0',
  position: 'relative',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
  },
});

const StyledScrollbar = styled(Scrollbar, {
  '--size': DEFAULT_SCROLLBAR_SIZE,
  display: 'flex',
  us: 'none',
  touchAction: 'none',
  background: '$gray300',
  transition: 'background 160ms ease-out',
  '&:hover': {
    background: '$gray400',
  },
  '&[data-orientation="vertical"]': { width: 'var(--size)' },
  '&[data-orientation="horizontal"]': {
    flexDirection: 'column',
    height: 'var(--size)',
  },
  variants: {
    size: {
      '1': {
        justifyContent: 'center',
        background: '$gray300',
        '&[data-orientation="vertical"]': { width: 6 },
        '&:hover': {
          background: '$gray300',
        },
        [`& ${StyledThumb}`]: {
          background: '$gray500',
          flex: '0 0 6px',
        },
      },
      '2': {
        justifyContent: 'center',
        background: '$gray300',
        '&[data-orientation="vertical"]': { width: 6 },
        '&:hover': {
          background: '$gray300',
        },
        [`& ${StyledThumb}`]: {
          background: '$gray500',
          flex: '0 0 6px',
        },
      },
      '3': {
        justifyContent: 'center',
        background: '$gray300',
        '&[data-orientation="vertical"]': { width: 4 },
        '&:hover': {
          background: '$gray300',
        },
        [`& ${StyledThumb}`]: {
          background: '$gray500',
          flex: '0 0 4px',
        },
        right: 'auto !important',
        left: 'calc(100% + 10px) !important',
      },
    },
  },
});

const StyledCorner = styled(Corner, {
  background: '$primary',
});

export const ScrollArea = StyledScrollArea;
export const ScrollAreaViewport = StyledViewport;
export const ScrollAreaScrollbar = StyledScrollbar;
export const ScrollAreaThumb = StyledThumb;
export const ScrollAreaCorner = StyledCorner;
